import { ComboBox } from '@interstate/components/ComboBox';
import { MileageCostOptionsSlideOut, useCustomMileageField } from '@makemydeal/dr-dash-components';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { OutOfFlowHost } from '../../../ScenarioGrid.style';
import { ScenarioRow } from '../../ScenarioRow';
import { MileageOptionsLabel } from './MileageOptionsLabel';

export const CustomMileageRow = () => {
    const { label, isLocked, hasOptions, isSlideOutOpen, toggleSlideOut, onKeyDown, onComboBoxFocus, comboBoxProps } =
        useCustomMileageField();
    const inputId = useScenarioCellId('annualMiles');

    return (
        <ScenarioRow
            rowKey="annualMiles"
            label={
                <MileageOptionsLabel
                    label={label}
                    inputId={inputId}
                    hasOptions={hasOptions}
                    isLocked={isLocked}
                    onOptionsActivate={toggleSlideOut}
                />
            }
        >
            <div onKeyDown={onKeyDown} onFocus={onComboBoxFocus}>
                <ComboBox {...comboBoxProps} id={inputId} label={label} displayLabel={false} />
            </div>
            {isSlideOutOpen && (
                <OutOfFlowHost>
                    <MileageCostOptionsSlideOut show={isSlideOutOpen} onHide={toggleSlideOut} />
                </OutOfFlowHost>
            )}
        </ScenarioRow>
    );
};
